import { authConstants } from '../../constant';

const initialState = { loggedIn: false, user: null, error: '' };

export const logout_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.LOGOUT_USER_ACTION_REQUEST:
      return {
        ...state,
        type: 'alert-success',
        message: action.payload,
      };
    case authConstants.LOGOUT_USER_ACTION_SUCCESS:
      return {
        ...state,
        loggedIn: false,
        user: null,
      };
    case authConstants.LOGOUT_USER_ACTION_FAILURE:
      return {
        ...state,
        type: 'alert-failure',
        message: action.payload,
      };
    default:
      return state;
  }
};

export const get_user_reducer = (state = initialState, action) => {
  switch (action.type) {
    case authConstants.GET_USER_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case authConstants.GET_USER_SUCCESS:
      return {
        ...state,
        loggedIn: true,
        user: action.payload,
        loading: false,
      };
    case authConstants.GET_USER_FAILURE:
      return {
        ...state,
        loggedIn: false,
        loading: false,
        user: null,
      };
    default:
      return state;
  }
};
